import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */

export class TrackingEventUserProfileEditMapper extends Mapper {
  constructor({config}) {
    super()

    this._config = config

    this._TRACKING_EVENT_NAMES = this._config.get('tracking').TRACKING_EVENT_NAMES
    this._fieldNameToTrackingIds = config.get('form').fieldNameToTrackingIds
  }

  setParams({fields, formErrors}) {
    this._fields = fields
    this._formErrors = formErrors
    return this
  }

  mapAccountEdited() {
    const emptyFields = []
    for (const field in this._fields) {
      if (!this._fields[field] && this._fieldNameToTrackingIds[field]?.property)
        emptyFields.push(this._fieldNameToTrackingIds[field].property)
    }
    return {
      event: this._TRACKING_EVENT_NAMES.ACCOUNT_EDITED,
      data: {form_fields: emptyFields.join(':'), form_name: 'editar mis datos'}
    }
  }

  mapAccountEditedError() {
    const errorFields = []

    for (const field in this._formErrors) {
      if (this._formErrors[field]?.length && this._fieldNameToTrackingIds[field]?.property)
        errorFields.push(this._fieldNameToTrackingIds[field].property)
    }

    return {
      event: this._TRACKING_EVENT_NAMES.ACCOUNT_EDITED_ERROR,
      data: {form_fields: errorFields.join(':'), form_name: 'editar mis datos'}
    }
  }

  map(eventName) {
    switch (eventName) {
      case this._TRACKING_EVENT_NAMES.ACCOUNT_EDITED:
        return this.mapAccountEdited()

      case this._TRACKING_EVENT_NAMES.ACCOUNT_EDITED_ERROR:
        return this.mapAccountEditedError()

      default:
        return {event: eventName}
    }
  }
}
